/* global gtag */

const TAGS_STORAGE_KEY = "attribution-tags";

export const captureAttributionTags = (tags) => {
  try {
    window.sessionStorage.setItem(TAGS_STORAGE_KEY, tags);
  } catch (e) {
    /* Don't fail when can't store them */
  }
};

const appendAttributionTagsToURL = (url) => {
  try {
    const tags = window.sessionStorage.getItem(TAGS_STORAGE_KEY);
    if (tags) {
      const queryParams = new URLSearchParams({ tags });
      return `${url}?${queryParams.toString()}`;
    }
  } catch (e) {
    /* Don't fail when can't retrieve them */
  }

  return url;
};

const useGoogleTagManager = () => {
  const trackClickToRegister = (url) => {
    var callback = function () {
      if (typeof (url) != 'undefined') {
        window.location = appendAttributionTagsToURL(url);
      }
    };
    gtag('event', 'conversion', {
      'send_to': 'AW-10951312400/uGk5CO_xmtADEJCI_-Uo',
      'event_callback': callback
    });
  };

  return { trackClickToRegister };
};

export default useGoogleTagManager;
